import React from "react";
import SocialLinks from "../Components/SocialMedia/SocialLinks"; 

function SocialMedia() {
  return (
    <>
      <main>
        <article id="fullpage">
          <SocialLinks />
        </article>
      </main>
    </>
  );
}

export default SocialMedia;
